import { Box, Typography } from '@mui/material';
import React, { Fragment } from 'react';

import { SplitCell } from './SplitCell';
import { StatusCell } from './StatusCell';

export const CELL_COLUMNS = ['status', 'quantity', 'packDetail', 'display'];

const cellSx = {
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 0,
  px: 1.5,
  py: 1,
  backgroundColor: '#eeeeee',
  borderRadius: 2,
};

const TextCell = ({ children }) => (
  <Box sx={{ ...cellSx, flex: 1 }}>
    <Typography variant="body2" fontWeight={500} noWrap>
      {children}
    </Typography>
  </Box>
);

const ProductRow = ({ item }) => {
  const renderColumn = column => {
    switch (column) {
      case 'status':
        return <StatusCell readOnly={item.readOnly} />;

      case 'quantity':
        return (
          <SplitCell
            values={[
              item.quantity ? `x${item.quantity}` : '-',
              item.packQuantity ? `x${item.packQuantity}` : '-',
            ]}
          />
        );

      case 'packDetail':
        return (
          <SplitCell
            values={[
              item.holdQuantity ? `x${item.holdQuantity}` : '-',
              item.packDisplay || '-',
            ]}
          />
        );

      case 'display':
        return <TextCell>{item.display ?? '-'}</TextCell>;

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: 40,
        minHeight: 40,
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      {CELL_COLUMNS.map(column => (
        <Fragment key={column}>{renderColumn(column)}</Fragment>
      ))}
    </Box>
  );
};

export { ProductRow };
